import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Layout } from "components";
import { validateNRIC } from "utils/nric";
import { validateMobile } from "utils/validateMobile";
import { useDispatch, batch } from "react-redux";
import { changeNric, changeMobile } from "redux/appointment";
import { changePreviousRouteName } from "redux/appointmentBooking";
import "../style.scss";

import { SING_PASS } from "constants/route";

export default function ActionConfirmation() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const initialValues = {
    nric: "",
    contactNo: ""
  };

  const validatedNRIC = (value) => {
    let error;
    if (!value) {
      error = "Please enter a valid NRIC / FIN / Passport number";
    } else if (!validateNRIC(value)) {
      error = "Invalid NRIC / FIN / Passport number";
    }
    return error;
  };

  const validatedMobile = (value) => {
    let error;
    if (!value) {
      error = "Mobile is required";
    } else if (!validateMobile(value.toString())) {
      error = "Invalid Mobile";
    }
    return error;
  };

  const submitHandler = (values, onSubmitProps) => {
    batch(() => {
      dispatch(changeNric(values.nric));
      dispatch(changeMobile(values.contactNo));
      dispatch(changePreviousRouteName(location.pathname));
    });
    console.log("Form data -> ", values);
    onSubmitProps.resetForm();
    navigate(SING_PASS);
  };

  return (
    <Layout>
      <div className="center text-secondary mt-3">
        <h2>Manage Your Appointment</h2>
        <div className="row">
          <div className="col-md-8 offset-md-2 text-start">
            Please submit information below to manage your appointment.
          </div>
        </div>
      </div>

      <Formik initialValues={initialValues} onSubmit={submitHandler}>
        {({ errors }) => (
          <Form>
            <div className="center row">
              <div className="col-md-8 offset-md-2">
                <div className="center info-wrapper text-secondary">
                  <div className="row d-flex justify-content-center my-3">
                    <div className="mb-3 col-md-10 col-lg-8">
                      <label
                        className="d-flex justify-content-start form-label"
                        htmlFor="nric"
                      >
                        NRIC
                      </label>
                      <Field
                        className="form-control"
                        type="text"
                        id="nric"
                        name="nric"
                        autoComplete="off"
                        validate={validatedNRIC}
                      />
                      <ErrorMessage name="nric">
                        {(errorMessage) => (
                          <div className="alert_message alignLeft">
                            {errorMessage}
                          </div>
                        )}
                      </ErrorMessage>
                    </div>
                  </div>
                  <div className="row d-flex justify-content-center my-3">
                    <div className="mb-3 col-md-10 col-lg-8">
                      <label
                        className="d-flex justify-content-start form-label"
                        htmlFor="contactNo"
                      >
                        Contact No:
                      </label>
                      <Field
                        className="form-control"
                        type="number"
                        id="contactNo"
                        name="contactNo"
                        autoComplete="off"
                        validate={validatedMobile}
                      />
                      <ErrorMessage name="contactNo">
                        {(errorMessage) => (
                          <div className="alert_message alignLeft">
                            {errorMessage}
                          </div>
                        )}
                      </ErrorMessage>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-1 d-flex justify-content-start col-sm-4 col-md-4 offset-md-2">
                <Button
                  className="btn cmp-button pbs-style--primary rounded-pill"
                  type="submit"
                >
                  Continue
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Layout>
  );
}
